export const AUTH_TYPE_CHOICES = [
  { id: 'oauth_client_credentials', name: 'data.authTypeOauthClientCredentials' },
  { id: 'client_certificate', name: 'data.authTypeClientCertificate' },
  { id: 'custom_headers', name: 'data.authTypeCustomHeaders' },
]

export const VALUE_TYPE_CHOICES = [
  { id: 'custom', name: 'data.valueTypeCustom' },
  { id: 'organization', name: 'data.valueTypeOrganization' },
  { id: 'user', name: 'data.valueTypeUser' },
]

export const USER_SOURCE_CHOICES = [
  { id: 'user.name', name: 'user.name' },
  { id: 'user.email', name: 'user.email' },
]
